import styled, { createGlobalStyle } from 'styled-components/macro';
import { Box, COLORS } from '@podiumhq/design-system';

import { FormElementsButton, FormElementsInputWrapper } from '../FormElements';

export const SelectPlanGlobalStyles = createGlobalStyle`
  html, body, #root {
    min-height: auto;
  }

  body {
    margin: 0;
  }
`;

export const SelectPlanCheckoutButton = styled(FormElementsButton)`
  margin-top: 8px;
`;

export const BillingAddressFormWrapper = styled(Box)`
  margin-top: 40px;

  // Todo, waiting for DS to give me a better way to style the select
  select,
  select.chakra-select {
    color: ${COLORS.grey.light};
    font-weight: normal;
  }
`;

export const SelectPlanCheckoutPaymentFieldsWrapper = styled(Box)`
  margin-top: 0;

  ${FormElementsInputWrapper} {
    flex: 1;
  }
`;

export const confirmDetailsTextStyles = {
  display: 'block',
  fontSize: 'md',
  fontWeight: 'normal',
  lineHeight: '21px',
  margin: '0',
};

export const paymentDetailsTitleStyles = {
  fontSize: 'lg',
  fontWeight: 'medium',
  mb: '16px',
};
